import { cn } from '@/lib/utils/cn';

export interface LogoProps {
  size?: 'sm' | 'md' | 'lg';
  showWordmark?: boolean;
  className?: string;
}

const markSize: Record<NonNullable<LogoProps['size']>, string> = {
  sm: 'h-5 w-5',
  md: 'h-6 w-6',
  lg: 'h-8 w-8',
};

const dotSize: Record<NonNullable<LogoProps['size']>, string> = {
  sm: 'h-2 w-2',
  md: 'h-2.5 w-2.5',
  lg: 'h-3 w-3',
};

const wordSize: Record<NonNullable<LogoProps['size']>, string> = {
  sm: 'text-base',
  md: 'text-lg',
  lg: 'text-xl',
};

export function Logo({ size = 'md', showWordmark = true, className }: LogoProps) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <span
        className={cn('flex items-center justify-center rounded bg-ink', markSize[size])}
        aria-hidden
      >
        <span className={cn('rounded-sm bg-board', dotSize[size])} />
      </span>
      {showWordmark ? (
        <span
          className={cn(
            'font-display font-semibold tracking-tight text-ink',
            wordSize[size],
          )}
        >
          Portfoli
        </span>
      ) : null}
    </span>
  );
}
